<app-layout
    [headerData]="header()"
    [headerData2]="header()"
    [headerData3]="header()"
    [headerData4]="header()"
    [headerData5]="header()"
    [headerData6]="header()"
    [headerData7]="header()"
    [languagesData]="languages()"
    [newsletterData]="newsletter()"
    [newsletterDataV2]="newsletterv2()"
    [modalMultipleMotorsData]="modalMultipleMotors()"
    [offerPopupV3Data]="offerPopupV3()"
    [selectorModal]="selectroModal()"
    [globalInfo]="globalInfo()"
>
    <router-outlet appBodyPageTypeClass></router-outlet>
</app-layout>
